export const SAVE_CHARACTERISTICS_ORDER_MUTATION = `mutation SaveCharacteristicsOrder($input: [OrderInput!]!) { 
saveCharacteristicsOrder(orderInput: $input) 
}
`